<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Create Customer Service Group</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Create Customer Service Group</h2>
    </div>

    <!-- form start -->
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
        <div class="row row-gap-4" formArrayName="groupName">
            <div class="col-12 col-lg-4 mb-3 mb-md-4" *ngFor="let item of groupName().controls; let i=index" [formGroupName]="i">
                <div class="bg-lighter border border-light rounded p-3 p-md-4 position-relative h-100">
                    <div class="d-flex flex-column row-gap-1">
                        <div class="form-group floating_form_field mb-0 w-100">
                            <input type="text" class="form-control" placeholder="Name"
                                formControlName="addgroupname" maxlength="200">
                            <label>Name</label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="groupName().controls[i].get('addgroupname').invalid && groupName().controls[i].get('addgroupname').touched"
                                class="small text-danger">
                                <div
                                    *ngIf="groupName().controls[i].get('addgroupname').errors?.required">
                                    Name is required
                                </div>
                            </div>
                            <!-- <div class="small text-muted ml-auto">Max 200 chars allowed.</div> -->
                        </div>
                    </div>
                    <button *ngIf="i !== 0" (click)="removeBlock(i)" class="btn btn-danger card_remove">
                        <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                    </button>
                </div>
            </div>
        </div>
        <div>
            <span class="text-primary font-weight-bold cursor-pointer" (click)="addMore()">+ Add More</span>
        </div>
        <div
            class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear text-muted" type="button" (click)="goToListPage()">Cancel</button>
            <button class="btn btn-primary" type="submit">Submit</button>
        </div>
    </form>
    <!-- form end -->
</div>